import { HomeViewProps } from './Home.types'
import Styles from './Home.oken.module.scss'
import Footer from 'components/Footer'
import { ReactComponent as OkenBanner } from 'openspace/assets/clients/oken/banner-modern.svg'
import BannerJPG from 'openspace/assets/clients/oken/banner.jpg'
import { useFeatures } from 'context/Feature'
import {
  GalleriesSection,
  LatestItensSection,
} from './Home.view.tsx'
import Spacing from '@onepercentio/one-ui/components/Spacing'
import Container from 'openspace/components/Container'
import Logo from 'templates/components/MainLayout/Logo/Logo.tsx'
import Text from 'openspace/components/Text/Text.tsx'
import { FigmaTypo, Typo } from 'containers/OneUIProvider/OneUIProvider.data.tsx'

/**
 * Where the user checks out the galeries
 **/
export default function HomeView(props: HomeViewProps) {
  const { hasGalleries } = useFeatures()
  return (
    <>
      <div className={`${Styles.okenBanner} dark`}>
        <Container>
          <div className={Styles.bannerContent}>
            <img src={Logo} alt='Oken' />
            <Text code="home.banner.title" type={FigmaTypo.H2} />
            <Spacing size='16'/>
            <Text code="home.banner.subtitle" type={Typo.h3heading} />
          </div>
        </Container>
      </div>
      <Spacing size='40' />
      <LatestItensSection
        key={'a'}
        drops={props.dropsPaginable}
        containerRef={props.dropsContainerRef}
      />
      {hasGalleries && (
        <GalleriesSection
          key={'g'}
          onSeeAll={() => props.onSeeAll('gallery')}
        />
      )}
      <Footer />
    </>
  )
}
